import * as React from 'react';

import { IconButton } from '../../buttons';
import { Styled } from './styled';

export const ButtonMenuSelectIcon = React.memo(({
  Icon,
  onClick,
  disabled,
}) => {
    return (
      <Styled.IconButton onClick={onClick} mood={disabled && 'disabled'}>
        <IconButton
          Icon={Icon}
          mood={disabled && 'disabled'}
        />
      </Styled.IconButton>
    );
  },
)
